import React from 'react';
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from 'components/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {} from 'styles/pages/staples-bulk-orders';

const StaplesOrderTypeModal = ({ state, setState, uploadPO }) => {
  const handleClose = () =>
    setState({
      ...state,
      staplesOrderTypeModal: false,
    });

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={state?.staplesOrderTypeModal}
      onClose={handleClose}
    >
      <DialogTitle>Select Order Type</DialogTitle>

      <DialogContent>
        <FormControlLabel
          label="Non Staples Order (AI order# will be added to quick books file)"
          control={
            <Checkbox
              checked={!state?.isStaplesOrder ? true : false}
              onClick={() => {
                setState({
                  ...state,
                  isStaplesOrder: false,
                });
              }}
            />
          }
        />
        <FormControlLabel
          label="Staples Order"
          control={
            <Checkbox
              checked={state?.isStaplesOrder ? true : false}
              onClick={() => {
                setState({
                  ...state,
                  isStaplesOrder: true,
                });
              }}
            />
          }
        />

        <div style={{ marginTop: 20 }}>
          <TextField
            type="date"
            label="Shipped Date"
            defaultValue={null}
            value={state?.staplesShipDate}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(v) =>
              setState({
                ...state,
                staplesShipDate: v,
              })
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!state?.staplesShipDate}
          onClick={() => {
            uploadPO();
          }}
          color="primary"
          variant="contained"
        >
          Upload PO
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StaplesOrderTypeModal;
